import styles from "./MainContainer.module.css";
// import Banner from "../../../images/baxkground.jpg";
import AnalyticsHeader from "../analyticsHeader/AnalyticsHeader";
import MainTopRight from "../mainTopRight/MainTopRight";
import MainMiddleRight from "../mainMiddleRight/MainMiddleRight";
import MainBottomRight from "../mainBottomRight/MainBottomRight";
import Sidebar from "../sidebar/Sidebar";
import DashboardPositions from "../DashBoardPosition/DashboardPositions";
const MainContainer = () => {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.left}>
        <AnalyticsHeader />
        {/* <DashboardPositions/> */}
        <DashboardPositions/>
      </div>
          <div className={styles.right}>
        {/* <MainTopRight /> */}
        <MainMiddleRight />
        <MainBottomRight />
      </div>
    </div>
  );
};

export default MainContainer;
